__turbopack_context__.v({
  "copyRight": "footer-module-scss-module__3QyO6a__copyRight",
  "footer": "footer-module-scss-module__3QyO6a__footer",
  "footerLink": "footer-module-scss-module__3QyO6a__footerLink",
  "footer__isUserLogged": "footer-module-scss-module__3QyO6a__footer__isUserLogged",
  "infoShare": "footer-module-scss-module__3QyO6a__infoShare",
  "links": "footer-module-scss-module__3QyO6a__links",
  "mediaLinks": "footer-module-scss-module__3QyO6a__mediaLinks",
});
